import { signOut } from '../auth/msal';

export function AccessDenied({ message }: { message: string }) {
  return (
    <div className="centred">
      <div className="panel">
        <h1>Access not available</h1>
        <p>{message}</p>
        <button type="button" className="btn" style={{ width: '100%', justifyContent: 'center' }} onClick={() => void signOut()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
